// extracted by mini-css-extract-plugin
module.exports = {"result":"result--FZ6ZM","services":"services--17YR3","active":"active--bfiRI","params":"params--1Cc3Q","operator":"operator--17JGu"};